<script lang="ts" setup>
const {
  options,
  selectedStatus,
  isMutating = false,
  errorMessage
} = defineProps<{
  options: { key: string; label: string; icon: string; color?: string }[];
  selectedStatus: string | null;
  isMutating?: boolean;
  errorMessage: string | null;
}>();

const emit = defineEmits<{
  select: [key: string];
}>();
</script>

<template>
  <div v-bind="$attrs">
    <v-alert
      v-if="errorMessage"
      type="error"
      variant="tonal"
      density="compact"
      class="mx-4 mt-4 mb-0 typography-body-sm"
      :text="errorMessage" />

    <div>
      <template v-for="(opt, index) in options" :key="opt.key">
        <v-divider v-if="index > 0" />
        <label
          v-ripple
          class="d-flex align-center gap-4 px-4 py-4"
          :class="{ 'opacity-50': isMutating }"
          :data-testid="`wizard-status-${opt.key}`">
          <input
            type="radio"
            name="wizard-status"
            :value="opt.key"
            :checked="selectedStatus === opt.key"
            :disabled="isMutating"
            class="sr-only"
            @change="emit('select', opt.key)" />
          <v-progress-circular v-if="isMutating" indeterminate size="24" color="primary" />
          <v-icon v-else size="24" :color="opt.color" :icon="opt.icon" />
          <span class="typography-body-md flex-fill">{{ opt.label }}</span>
        </label>
      </template>
    </div>
  </div>
</template>

<style scoped>
label {
  cursor: pointer;
}
</style>
